var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgodaoMobImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 135,
    viewBox: "0 0 127 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.4785 50.356C61.9916 49.4225 64.7564 49.4225 67.2695 50.356L122.186 70.7552C123.531 71.2549 123.542 73.1536 122.203 73.6692L67.7254 94.6413C65.1521 95.6319 62.3036 95.6373 59.7266 94.6564L4.57264 73.6631C3.22876 73.1515 3.23641 71.2477 4.58436 70.747L59.4785 50.356Z",
    fill: "url(#paint0_radial_40_490)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_40_490)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M67.0731 41.5987L120.305 61.3722C121.75 61.9089 121.762 63.9484 120.323 64.5022L67.5227 84.8286C65.0792 85.7693 62.3744 85.7744 59.9273 84.843L6.46266 64.4927C5.01911 63.9432 5.02732 61.8982 6.47524 61.3603L59.675 41.5987C62.0613 40.7123 64.6867 40.7123 67.0731 41.5987Z",
    fill: "url(#paint1_radial_40_490)",
    fillOpacity: 0.72,
    stroke: "#FED0D0",
    strokeWidth: 1.12835
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.611 38.5312C43.5012 38.5312 44.2229 39.2529 44.2229 40.1432L43.1102 62.7103C43.1102 64.7892 42.1117 64.7892 42.1117 62.7103L40.999 40.1432C40.999 39.2529 41.7207 38.5312 42.611 38.5312Z",
    fill: "url(#paint2_linear_40_490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4625 53.0381C77.3528 53.0381 78.0745 53.7598 78.0745 54.65L76.9618 75.6052C76.9618 77.6841 75.9632 77.6841 75.9632 75.6052L74.8506 54.65C74.8506 53.7598 75.5723 53.0381 76.4625 53.0381Z",
    fill: "url(#paint3_linear_40_490)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4918 27.248C27.3821 27.248 28.1038 27.9697 28.1038 28.86L26.9911 70.7703C26.9911 72.7501 25.9925 72.7501 25.9925 70.7703L24.8799 28.86C24.8799 27.9697 25.6016 27.248 26.4918 27.248Z",
    fill: "url(#paint4_linear_40_490)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.6709 65.9341L50.6709 77.1213",
    stroke: "url(#paint5_linear_40_490)",
    strokeWidth: 3.22387,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.1182 49.8145L57.1182 59.1371",
    stroke: "url(#paint6_linear_40_490)",
    strokeWidth: 3.22387,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9098 17.5762C83.8 17.5762 84.5217 18.2979 84.5217 19.1881L83.4091 54.6507C83.4091 56.7296 82.4105 56.7296 82.4105 54.6507L81.2979 19.1881C81.2979 18.2979 82.0195 17.5762 82.9098 17.5762Z",
    fill: "url(#paint7_linear_40_490)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.088 36.9194C107.978 36.9194 108.699 37.6411 108.699 38.5314L107.587 64.3223C107.587 66.4012 106.588 66.4012 106.588 64.3223L105.476 38.5314C105.476 37.6411 106.197 36.9194 107.088 36.9194Z",
    fill: "url(#paint8_linear_40_490)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5645 3.56836C64.4863 3.56836 65.2335 4.39991 65.2335 5.42568L64.0814 40.7149C64.0814 43.1102 63.0475 43.1102 63.0475 40.7149L61.8955 5.42568C61.8955 4.39991 62.6427 3.56836 63.5645 3.56836Z",
    fill: "url(#paint9_linear_40_490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_40_490",
    x: 2.37259,
    y: 37.9218,
    width: 122.035,
    height: 50.6281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.22392
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_40_490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_40_490",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.374 72.1895) rotate(-179.341) scale(54.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.374 62.9033) rotate(-179.341) scale(54.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0345502,
    stopColor: "#E47272",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E16C6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_490",
    x1: 43.1673,
    y1: 40.1432,
    x2: 43.1673,
    y2: 62.7103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186384,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_490",
    x1: 77.0188,
    y1: 54.65,
    x2: 77.0188,
    y2: 75.6052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD676D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD676D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_490",
    x1: 27.0481,
    y1: 28.86,
    x2: 27.0481,
    y2: 70.7703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578328,
    stopColor: "#E17C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17C81",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_490",
    x1: 51.1709,
    y1: 65.9341,
    x2: 51.1709,
    y2: 77.1213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_490",
    x1: 57.6182,
    y1: 49.8145,
    x2: 57.6182,
    y2: 59.1371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_490",
    x1: 83.4661,
    y1: 19.1881,
    x2: 83.4661,
    y2: 54.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#3F4048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_490",
    x1: 107.644,
    y1: 38.5314,
    x2: 107.644,
    y2: 64.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.610377,
    stopColor: "#DE6B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6B71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40_490",
    x1: 64.1405,
    y1: 5.42568,
    x2: 64.1405,
    y2: 40.7149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF6E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF6E74",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgodaoMobImg);
export default __webpack_public_path__ + "static/media/algodao-mob-img.ffa6a90a474253065f687c6b853c2d83.svg";
export { ForwardRef as ReactComponent };